import React from "react";
import { useSelector } from "react-redux";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

const AgreementsAnalysisTable = () => {
  let { tableValues, tableLinks, rawDataLink, colHeaders, columns } = useSelector(
    (state) => state.agreementsAnalysis.chartData
  );

  return (
    <TableWithCustomSearch
      data={tableValues}
      colHeaders={colHeaders}
      columns={columns}
      rawDataLink={rawDataLink}
      fileName="agreements-analysis"
      links={tableLinks}
    />
  );
};

export default AgreementsAnalysisTable;
